module.exports = "//public.getcloudapp.com/packs/media/images/add-cta-active-6a10f219ec7747c6c01d4cc5a779c756.svg";